import { render, staticRenderFns } from "./EditModelConfiguration.vue?vue&type=template&id=6296c23d&scoped=true&"
import script from "./EditModelConfiguration.vue?vue&type=script&lang=js&"
export * from "./EditModelConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./EditModelConfiguration.vue?vue&type=style&index=0&id=6296c23d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6296c23d",
  null
  
)

export default component.exports